/**
 *
 * Search button toggle (JS)
 *
 * @author Space-Time Inc.
 *
 */


document.addEventListener('DOMContentLoaded', function () {

	initializeSearch();

	function initializeSearch() {
		const searchBtn = document.getElementsByClassName('site-header-nav-search')[0];
		const closeBtn = document.getElementsByClassName('site-header-nav-bar-search-close')[0];
		const panel = document.getElementsByClassName('site-header-nav-bar-search')[0];

		searchBtn.addEventListener('click', () => {
			if (searchBtn.classList.contains('active')) {
				searchBtn.classList.remove('active');
				panel.classList.remove('active');
			} else {
				searchBtn.classList.add('active');
				panel.classList.add('active');
			}
		});
		closeBtn.addEventListener('click', () => {
			searchBtn.classList.remove('active');
			panel.classList.remove('active');
		});
	}

});
